import React from 'react';
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import i18n from '../../i18n';
import ListItemText from '@mui/material/ListItemText';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { Download } from '@mui/icons-material';
import Scrollbar from '../../components/scrollbar';
import { formatName } from '../../utils/formatName';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadService from '../../services/uploadService/UploadService';

export default class DocumentsDialog extends React.Component {
    onCancel = () => {};
    fetchData = () => {};

    constructor(props) {
        super(props);

        this.state = {
            dialogOpen: props.dialogOpen || false,
            dialogData: props.dialogData || [],
            comment: '',
            alertError: ''
        };

        this.onCancel = props.onCancel;
        this.fetchData = props.fetchData;
        this.fileService = new FileUploadService(
            this.props.context.getState().server
        );
    }

    static getDerivedStateFromProps(props, state) {
        if (
            props.dialogOpen !== state.dialogOpen ||
            props.dialogData !== state.dialogData
        ) {
            return {
                dialogOpen: props.dialogOpen,
                dialogData: props.dialogData,
                comment: '',
                alertError: ''
            };
        }

        return null;
    }

    handleOpenFile = async (file) => {
        let fileUuid = file.uuid;
        if (!fileUuid) {
            fileUuid = this.getUuidFromName(file.name);
        }
        if (!fileUuid) {
            this.setState({ alertError: i18n.t('errors.fileNotFound') });
            return;
        }
        try {
            await this.fileService.downloadFile(fileUuid);
        } catch (error) {
            this.setState({ alertError: error.message });
        }
    };

    handleUploadFile = async (event) => {
        const file = event.target.files[0];
        const { comment } = this.state;
        const id = this.props.id;
        const type = this.props.type;

        try {
            await this.fileService.uploadFile(file, type, id, comment);
        } catch (error) {
            this.setState({ alertError: error.message });
            return;
        }
        this.setState({
            comment: '',
            alertError: ''
        });
        this.fetchData();
    };

    sortData = (data) => {
        if (!data) return [];
        return data.sort((a, b) => {
            return b.id - a.id;
        });
    };
    // temp, not used
    getUuidFromName(name) {
        //                 "name": "appeal/cedcbc70-7877-474c-b14b-526906720b84.docx",
        if (!name) return null;
        const parts = name.split('/');
        if (parts.length !== 2) return null;
        const filename = parts[1];
        const uuid = filename.split('.')[0];
        return uuid;
    }

    renderUploadForm(comment, alertError = '') {
        return (
            <Stack direction="column" spacing={2} mt={2} sx={{ width: '100%' }}>
                <Typography variant="subtitle2">
                    Enter a comment and upload a new document
                </Typography>
                <TextField
                    value={comment}
                    onChange={(event) =>
                        this.setState({
                            comment: event.target.value
                        })
                    }
                    label={i18n.t('columns.comment')}
                    variant="outlined"
                    sx={{ width: '100%' }}
                />
                <Button
                    component="label"
                    variant="outlined"
                    startIcon={<UploadFileIcon />}
                    sx={{ mr: '1', mt: 1, height: '55px' }}
                >
                    {i18n.t('buttons.uploadDocument')}
                    <input
                        type="file"
                        accept="application/pdf"
                        hidden
                        onChange={(event) => this.handleUploadFile(event)}
                    />
                </Button>
                {alertError && <Alert severity={'error'}>{alertError}</Alert>}
            </Stack>
        );
    }

    render() {
        const { dialogData, comment, alertError } = this.state;
        const sortedData = this.sortData(dialogData);
        return (
            <Dialog
                open={this.state.dialogOpen}
                onClose={this.onCancel}
                maxWidth="sm"
                fullWidth={!!dialogData?.length}
            >
                <DialogTitle>{i18n.t('dialogs.documentsTitle')}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={this.onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    {dialogData?.length === 0 ? (
                        <Box
                            key={0}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '200px'
                            }}
                        >
                            {this.renderUploadForm(comment, alertError)}
                        </Box>
                    ) : (
                        <>
                            <Scrollbar
                                sx={{
                                    width: '100%',
                                    maxHeight: '300px',
                                    pt: '20px',
                                    mb: '20px'
                                }}
                            >
                                <List>
                                    {sortedData?.map((item, index) => {
                                        const user = item.user || {};
                                        return (
                                            <ListItem key={index}>
                                                <ListItemButton
                                                    onClick={() =>
                                                        this.handleOpenFile(
                                                            item?.file
                                                        )
                                                    }
                                                >
                                                    <ListItemText
                                                        primary={
                                                            item?.file?.name
                                                        }
                                                        primaryTypographyProps={{
                                                            overflow: 'hidden',
                                                            textOverflow:
                                                                'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                        secondary={
                                                            //authored by: {item.user.firstName} {item.user.lastName} + comment
                                                            <>
                                                                {item.comment}
                                                                <br />
                                                                {i18n.t(
                                                                    'dialogs.uploadedBy'
                                                                )}
                                                                :{' '}
                                                                {formatName(
                                                                    user.firstName,
                                                                    user.lastName
                                                                )}
                                                            </>
                                                        }
                                                    />
                                                    <Download />
                                                </ListItemButton>
                                            </ListItem>
                                        );
                                    })}
                                </List>
                            </Scrollbar>

                            <Divider />

                            {this.renderUploadForm(comment, alertError)}
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => this.onCancel()}>
                        {i18n.t('buttons.ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
